import { ele, TalkerAPI } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";

export default class PageOpDelete
{
    constructor(targetElement)
    {
        this._talkerAPI = new TalkerAPI(window.parent);

        const ops = ele.byQueryAll("#oplist .op");
        const opIds = [];
        ops.forEach((op) =>
        {
            opIds.push(op.dataset.opid);
        });

        const loadingEle = ele.byId("checkDelete");
        const deleteButton = ele.byId("deletebutton");
        const containerEle = ele.byId("problems");

        let responseReceived = 0;
        let allowDelete = true;
        const successCb = (opId, response) =>
        {
            responseReceived++;
            const count = response.data.projectsCount || 0;
            const opCount = response.data.opsCount || 0;
            if (count || opCount)
            {
                const opIssuesEle = ele.byId("issues_" + opId);
                if (opIssuesEle)
                {
                    const countEle = opIssuesEle.querySelector(".countProjects");
                    const opCountEle = opIssuesEle.querySelector(".countOps");
                    const countPlural = countEle.querySelector(".plural");
                    const opCountPlural = opCountEle.querySelector(".plural");
                    if (countEle) ele.hide(countEle);
                    if (opCountEle) ele.hide(opCountEle);
                    if (count > 1 && countPlural) ele.show(countPlural);
                    if (opCount > 1 && opCountPlural) ele.show(opCountPlural);

                    if (countEle && count)
                    {
                        countEle.querySelector(".count").innerText = count;
                        ele.show(countEle);
                    }
                    if (opCountEle && opCount)
                    {
                        opCountEle.querySelector(".count").innerText = opCount;
                        ele.show(opCountEle);
                    }
                    if (containerEle) ele.show(containerEle);
                    ele.show(opIssuesEle);
                    allowDelete = false;
                }
            }

            if (responseReceived === ops.length)
            {
                if (loadingEle) ele.hide(loadingEle);
                if (allowDelete && deleteButton) ele.show(deleteButton);
            }
        };

        const errorCB = (e) =>
        {
            responseReceived++;
            if (responseReceived === ops.length)
            {
                if (loadingEle) ele.hide(loadingEle);
            }
        };

        opIds.forEach((opId) =>
        {
            const url = "op/" + opId + "/dependencies";
            api.get(url, (r) => { successCb(opId, r); }, errorCB);
        });
    }

    deleteOps(ops)
    {
        ops = web.parseDustJson(ops, []);
        const deleteButton = ele.byQuery("#deletebutton .button");
        const errorEle = ele.byQuery("#deletebutton .error");

        const opIdentifiers = [];
        ops.forEach((op) =>
        {
            if (op.id)
            {
                opIdentifiers.push(op.id);
            }
            else if (op.name)
            {
                opIdentifiers.push(op.name);
            }
        });
        web.buttons.startSavingAnimButton(deleteButton);
        api.post(
            "ops/delete",
            { "opIdentifiers": opIdentifiers },
            (res) =>
            {
                let msg = res.msg || JSON.stringify(res);
                web.buttons.stopSavingAnimButton();
                if (res.success)
                {
                    this._talkerAPI.send("opsDeleted", { "ops": ops });
                    const infoEle = ele.byId("hints");
                    if (infoEle)
                    {
                        ele.hide(infoEle);
                    }
                    if (errorEle)
                    {
                        errorEle.classList.remove("error");
                        errorEle.classList.add("info");
                        errorEle.innerText = "Successfully deleted " + ops.length + " ops.";
                        ele.show(errorEle);
                    }
                    ele.hide(deleteButton);
                }
                else
                {
                    if (errorEle)
                    {
                        errorEle.innerText = "Failed to delete op: " + msg;
                        ele.show(errorEle);
                    }
                }
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton();
                let msg = res.msg || JSON.stringify(res);
                if (errorEle)
                {
                    errorEle.innerText = "Failed to delete op: " + msg;
                    ele.show(errorEle);
                }
            });
        // }
    }
}
